// UIKIT JS Imports
import UIkit from 'uikit';
import Icons from 'uikit/dist/js/uikit-icons';

// Core styles
import './styles/app.scss';

// App JS
import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import * as serviceWorker from './serviceWorker';
UIkit.container = '#root';
// sloads the Icon plugin
UIkit.use(Icons);

ReactDOM.render(<App />, document.getElementById('root'));

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();

// DOM ready
UIkit.util.ready(function () {
    document.addEventListener("mousewheel", function(evt){
        if(document.activeElement.type === "number"){
            document.activeElement.blur();
        }
    });
});